import React from 'react';
import { motion } from 'framer-motion';
import { Check, Crown } from 'lucide-react';
export function PackageList() {
  const features = ['Mirror Photo Booth de lujo — espejo oval con iluminación LED cinematográfica', 'Instalación y configuración profesional', 'Atendente dedicado durante todo el evento', 'Fotos impresas ilimitadas durante el evento', 'Diseño personalizado con el nombre y fecha de tu celebración', 'Fondo/backdrop elegante incluido', 'Galería digital para compartir en redes', 'Atención en español de principio a fin', 'Puntualidad y profesionalismo garantizado'];
  return <section className="py-20 md:py-28 bg-ink relative" data-id="element-464">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-465">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-charcoal to-ink rounded-3xl p-8 md:p-12 shadow-2xl border border-gold/30 relative overflow-hidden" data-id="element-466">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-32 bg-gold/10 blur-[100px] pointer-events-none" data-id="element-467"></div>

          <div className="text-center mb-12 relative z-10" data-id="element-468">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-6" data-id="element-469">
              <Crown className="w-8 h-8 text-gold" data-id="element-470" />
            </div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-4" data-id="element-471">
              El Paquete Completo
            </h2>
            <p className="text-lg text-cream/80 font-light max-w-2xl mx-auto" data-id="element-472">
              Cuando nos contratas, no estás rentando un equipo. Estás
              contratando una experiencia completa:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 relative z-10" data-id="element-473">
            {features.map((feature, index) => <div key={index} className={`flex items-start gap-3 p-3 rounded-lg hover:bg-white/5 transition-colors ${index === 0 ? 'md:col-span-2 bg-gold/5 border border-gold/20 p-4 rounded-xl' : ''}`} data-id="element-474">
                <Check className={`shrink-0 mt-1 ${index === 0 ? 'w-6 h-6 text-gold' : 'w-5 h-5 text-gold/80'}`} data-id="element-475" />
                <span className={`${index === 0 ? 'text-lg font-medium text-gold' : 'text-cream/90 font-light'}`} data-id="element-476">
                  {feature}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}